import React from 'react'
import OrdersTable from '../tables/OrdersTable'

const Orders = () => {
  return (
   <OrdersTable/>
  )
}

export default Orders